import React, { useEffect, useState } from 'react';
import HeroBgImage from '../images/HeroBgImage.jpg';
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosConfig";


const HeroSection = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

   useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/Products");
        if (res.data?.products) {
          setProducts(res.data.products);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/product?search=${encodeURIComponent(searchTerm)}`);
    } else {
      navigate("/product");
    }
  };

  const handleBuyNow = (id) => {
    navigate(`/product?id=${id}`);
  };

  const handleSuggestionClick = (title) => {
    setSearchTerm(title);
    navigate(`/product?search=${encodeURIComponent(title)}`);
  };

  useEffect(() => {
    const filtered = products
      .filter(product =>
        product.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .slice(0, 5);
    setSuggestions(searchTerm ? filtered : []);
  }, [searchTerm, products]);

  return (
    
    <section className="hero position-relative w-100 overflow-hidden">
      <img
        src={HeroBgImage}
        alt="Background"
        className="hero-bg position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
        style={{ filter: 'brightness(0.4)', zIndex: 0 }}
      />
      <div className="hero-overlay d-flex align-items-center justify-content-center h-100 px-3 p-md-5">
        <div className="container">
          <div className="hero-text text-center">
            <h1 className="heading">தெய்வீகம் வழிகாட்டும், வைதீகம் வணங்கும், சித்தாந்தம் வாழ்க!</h1>
            <p className="subHead">
              <span className="fw-bold">Shop by Intention:</span> Protection & Positivity, Career & Wealth, Love & Relationships, Peace & Meditation
            </p>

            <div className="search-container position-relative">
              <input
                type="text"
                placeholder="Search Product"
                className="form-control search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              />
              <div className="search-icon" onClick={handleSearch}>
                <CiSearch /> <span className="search-text">Search</span>
              </div>

              {suggestions.length > 0 && (
                <ul className="suggestion-list list-group">
                  {suggestions.map(item => (
                    <li
                      key={item._id}
                      className="list-group-item suggestion-item"
                      onClick={() => handleSuggestionClick(item.title)}
                    >
                      {item.title}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {loading ? (
              <div className="d-flex justify-content-center align-items-center mt-4">
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              products.length > 0 && (
                <div className="product-marquee">
                  <div className="marquee-track">
                    {products.map(product => (
                      <div className="marquee-card card text-center" key={product._id}>
                        <div className="image-wrapper position-relative">
                          <img
                            src={`${axiosInstance.defaults.baseURL}${product.images[0]?.url}`} 
                            className="card-img-top object-fit-contain"
                            alt={product.title}
                            style={{ height: '150px', objectFit: 'contain' }}
                          />
                          <div className="price-overlay text-white fw-bold rounded px-2 py-1">
                            ₹{product.offerPrice > 0 ? product.offerPrice : product.CurrentPrice}
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="text-start">
                            <h6 className="card-title text-truncate-2-lines">{product.title}</h6>
                          </div>
                          <button
                            className="btn btn-primary btn-sm text-light mt-2"
                            onClick={() => handleBuyNow(product._id)}
                          >
                            Buy Now
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
